<template>
  <div class="index">
    <div class="content">
      <img class="index_logo" src="../../assets/images/download/logo.png" alt />
      <p class="index_title">{{dataArr.title}}</p>
      <p class="index_sales">{{dataArr.discount_content}}</p>
      <p class="index_expiry">有效期：{{distance(dataArr.start_time)}}-{{distance(dataArr.end_time)}}</p>
      <p class="index_available">可用时间：周一至周五10:00-20:00</p>
      <div class="dashed"></div>
      <div class="second_title1">
        <span class="key">优惠说明：</span>
        <span class="name">用户可凭券在家庭中医馆APP中购买药品</span>
      </div>
      <div class="second_title2">
        <span class="key">使用说明：</span>
        <span class="name">
          1、每笔订单限用一张
          <br />
          2、仅限问诊-签约医生可用
          <br/>
          3、{{dataArr.content}}
        </span>
      </div>
    </div>
    <div class="submit" @click="changeget">立即领取</div>
    <!-- <div class="submit" @click="openApp">立即领取</div> -->
    <div class="phone_bg" @click="cleardata" v-show="isshowphone"></div>
    <div class="phone_bg" v-show="isshowalert"></div>
    <div class="phone_bg" v-show="isshowsuccess"></div>
    <!-- 手机号填写 -->
    <div class="phone_content" v-show="isshowphone">
      <p class="phone_title">领取至手机号</p>
      <p class="inputbox">
        <span class="area_code" @click="isshowarea=true">+{{area_code}}</span>
        <input
          class="inputphone"
          name="phone"
          id="phoneid"
          type="number"
          ref="phoneid"
          placeholder="请输入手机号"
          v-model="phone"
        />
      </p>
      <p class="inputbox">
        <input class="inputtest" v-model="verification" type="number" placeholder="请输入验证码" />
        <button type="button" :disabled="disabled" @click="sendcode" class="timebtns">{{btntxt}}</button>
      </p>
      <div class="phone_submit" @click="submit">完成</div>
    </div>
    <!-- 选择区号弹窗 -->
    <van-popup v-model="isshowarea" position="bottom" :style="{ height: '50%' }">
      <van-cell-group>
        <van-cell
          v-for="(item,index) in area_codeArr"
          :key="index"
          :title="item.name"
          :value="'+'+item.code"
          @click="changearea(item)"
          size="large"
        />
      </van-cell-group>
    </van-popup>
    <!-- 领取成功 -->
    <div class="success_content" v-show="isshowsuccess">
      <img class="success_img" src="../../assets/images/download/success.png" alt />
      <p class="success_text">领取成功</p>
      <p class="success_push" @click="push_app">点击立即查看</p>
    </div>
    <!-- 提示右上角 -->
    <div class="right_top" v-show="isshowalert">
      <img class="rt_img" src="../../assets/images/download/download.png" alt />
      <p class="rt_text">
        请点击右上角,
        <br />点击使用浏览器即可打开
      </p>
      <!-- <p class="rt_text">
        点击右上角，选择在浏览器中
        <br />打开即可完成下载
      </p>-->
    </div>
    <!-- 提示 -->
    <div class="alert_content" v-show="isshowalert">
      <p class="alert_title">
        温馨提示
        <span @click="isshowalert=false">取消</span>
      </p>
      <p class="alert_text">您还没有家庭中医馆APP暂时不能查看优惠券，去点击下载</p>
    </div>
  </div>
</template>
<script>
import http2 from "../../util/hermerApiConfig";
import http from "../../util/gaeaApiConfig";
import http3 from "../../util/pontusApiConfig";
import CallApp from "callapp-lib";
export default {
  data() {
    return {
      dataArr: {},
      coupon_id:0,
      isshowarea: false,
      isshowphone: false,
      isshowalert: false,
      isshowsuccess: false,
      disabled: false,
      time: 0,
      btntxt: "获取验证码",
      area_code: "",
      area_codeArr: {},
      phone: "",
      verification: "",
      coupon_type: "drug_reduce"
    };
  },
  created() {
    this.coupon_id = this.$route.query.id
    this.getinfo();
    this.getcode();
  },
  mounted() {},
  methods: {
    getcode() {
      let that = this;
      http2.get("area_codes").then(function(res) {
        // console.log(res);
        if (res.data.status_code == 200) {
          that.area_codeArr = res.data.data;
          that.area_code = res.data.data[0].code;
        }
      });
    },
    getinfo() {
      let that = this;
      let params = {
        id: 1
      };
      let url = "h5/coupon/"+this.coupon_id
      http3.get(url, { params }).then(function(res) {
        console.log(res);
        if (res.data.status_code == 200) {
          that.dataArr = res.data.data;
        }
      });
    },
    changeget(){
      let time = new Date()
      time = parseInt(time.getTime()/1000)
      // console.log(time)
      // console.log(this.dataArr.end_time)
      if(this.dataArr.end_time < time){
        // console.log(1111)
        this.$toast.fail('优惠券已过期');
      }else{
        // console.log(2222)
        this.isshowphone = true

      }
    },
    changearea(item) {
      // console.log(item)
      this.area_code = item.code;
      this.isshowarea = false;
    },
    cleardata() {
      this.isshowphone = false;
      this.phone = "";
      this.verification = "";
    },
    sendcode() {
      var reg = 11 && /^1\d{10}$/;
      let that = this;
      if (this.phone == "") {
        alert("请输入手机号码");
      } else if (!reg.test(this.phone)) {
        alert("手机格式不正确");
      } else {
        this.time = 60;
        let params = {
          phone: that.phone,
          area_code: that.area_code.toString()
        };
        // console.log(params);
        http.post("sms_code", params).then(function(res2) {
          // console.log(res2);
          if (res2.data.status_code === 4001) {
          } else if (res2.data.status_code == 200) {
            that.timer();
            that.disabled = true;
          }
        });
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    submit() {
      var that = this;
      if (this.verification && this.phone) {
        var params = {
          phone: this.phone,
          area_code: this.area_code.toString(),
          verification_code: this.verification
        };
        // console.log(params)
        http.post("sms_code/verify", params).then(function(res) {
          if (res.data.status_code == 200) {
            let data = {
              phone: that.phone,
              area_code: that.area_code.toString()
            };
            // console.log(data)
            let url = "h5/coupon/"+that.coupon_id
            http3.post(url, data).then(function(res2) {
              // console.log(res2);
              if (res2.data.status_code == 200) {
                that.isshowphone = false;
                that.isshowsuccess = true;
              }else{
              }
            });
          }
        });
        // that.isshowphone = false;
        // that.isshowsuccess = true;
      } else if (!this.phone) {
        alert("手机号不能为空");
      } else if (!this.verification) {
        alert("验证码不能为空");
      }
    },
    iswechat() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    distance(day) {
      //过去的时间戳
      var now = new Date(day * 1000);
      //过去
      //年
      var year = now.getFullYear();
      //月
      var month = now.getMonth() + 1;
      //日
      var date = now.getDate();
      //时
      var hour = now.getHours();
      //分
      var minute = now.getMinutes();
      //秒
      var second = now.getSeconds();

      var timer =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;

      return timer;
    },
    push_app() {
      if (this.iswechat()) {
        this.isshowsuccess = false;
        this.isshowalert = true;
      } else {
        // alert("go app");
        this.openApp();
      }
    },
    openApp() {
      // 是微信内部webView
      // if (this.iswechat()) {
      //   alert("请点击右上角按钮, 点击使用浏览器打开");
      // } else {
      const options = {
        scheme: { protocol: "haiwei" }, //要打开的 APP 的标识
        intent: {
          package: "com.haiwei.medicine_family", //包名
          scheme: "haiwei"
        },
        //apple store
        appstore: "https://apps.apple.com/cn/app/xxx/xxxx",
        //应用宝
        yinyongbao:
          "https://sj.qq.com/myapp/detail.htm?apkName=com.xxxx.bloodpressure",
        fallback: "https://www.baidu.com/" //唤端失败后跳转的地址
      };
      const callLib = new CallApp(options);
      callLib.open({
        path: "/app",
        param: {
          type: 1,
          id: 1
        }
      });
      // }
    }
  }
};
</script>
<style lang="scss">
.index {
  width: 100%;
  padding-top: 53px;
  .content {
    margin: 0 auto;
    width: calc(100% - 30px);
    height: 425px;
    // margin-top: 53px;
    background: rgba(242, 242, 242, 1);
    border-radius: 15px;
    position: relative;
    border: 1px solid transparent;
    .index_logo {
      // margin: 0 auto;
      width: 72px;
      height: 72px;
      display: block;
      position: absolute;
      top: -36px;
      left: calc(50% - 36px);
    }
    & > p {
      font-family: PingFang-SC-Bold;
      text-align: center;
    }
    .index_title {
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 26px;
      margin-top: 70px;
    }
    .index_sales {
      color: #ac4b38;
      font-size: 21px;
      margin-top: 12px;
    }
    .index_expiry {
      color: #666666;
      font-size: 14px;
      margin-top: 33px;
    }
    .index_available {
      color: #666666;
      font-size: 14px;
      margin-top: 6px;
    }
    .dashed {
      width: 100%;
      height: 1px;
      margin: 0 auto;
      background-image: linear-gradient(
        to right,
        #bfbfbf 0%,
        #bfbfbf 60%,
        transparent 40%
      );
      background-size: 8px 1px;
      background-repeat: repeat-x;
      margin-top: 28px;
      //   margin-left: -20px;
    }
    .second_title1,
    .second_title2 {
      padding: 0px 17px;
      line-height: 30px;
      font-size: 16px;
      span {
        display: table-cell;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
      }
      .key {
        color: #666;
        width: 82px;
        text-align-last: justify;
      }
    }
    .second_title1 {
      margin-top: 20px;
    }
    .second_title2 {
      margin-top: 16px;
    }
  }
  .submit {
    width: 155px;
    height: 43px;
    border-radius: 4px;
    background: #ac4b38;
    text-align: center;
    line-height: 43px;
    color: #fff;
    font-size: 17px;
    margin: 0 auto;
    margin-top: 50px;
  }
  .phone_bg {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0.35);
  }
  .area_content,
  .phone_content,
  .alert_content,
  .success_content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: calc(100% - 75px);
    background: #fff;
    border-radius: 10px;
    border: 1px solid transparent;
  }
  .area_content {
    height: 500px;
  }
  .phone_content {
    height: 344px;
    .phone_title {
      margin-top: 26px;
      text-align: center;
      color: #333;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .area_code {
      color: #8a8a8a;
      display: inline-block;
      height: 60px;
      line-height: 56px;
      &::after {
        content: "";
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("../../assets/images/download/down.png") no-repeat center center;
        background-size: cover;
        vertical-align: middle;
        margin-left: 3px;
      }
    }
    .inputbox {
      width: 90%;
      height: 60px;
      margin: 0 auto;
      /*border: 1px solid red;*/
      border-bottom: 1px solid #cccccc;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      // margin-top: 0.4rem;
      /*padding: 0.4rem 0rem;*/
      /*display: flex;*/
      /*justify-content: space-around;*/
    }
    .inputphone,
    .inputtest {
      height: 60px;
      border: none;
      /*border: 1px solid red;*/
      // text-indent: 0.5rem;
      font-size: 1rem;
      outline: none;
      -webkit-appearance: none;
    }

    .inputphone {
      width: 73%;
    }

    .inputtest {
      width: 71%;
    }

    .timebtns {
      width: 27%;
      height: 32px;
      background: #ac4b38;
      color: #fff;
      border: none;
      border-radius: 4px;
      font-size: 1rem;
      box-sizing: border-box;
      outline: none;
      font-size: 12px;
    }
    .phone_submit {
      width: 200px;
      height: 43px;
      line-height: 43px;
      border-radius: 4px;
      background: #ac4b38;
      text-align: center;
      color: #fff;
      font-size: 17px;
      margin: 0 auto;
      margin-top: 60px;
    }
  }
  .success_content {
    height: 240px;
    text-align: center;
    .success_img {
      width: 80px;
      height: 80px;
      display: block;
      margin: 0 auto;
      margin-top: 40px;
    }
    .success_text {
      margin-top: 20px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      font-size: 18px;
    }
    .success_push {
      color: #ac4838;
      margin-top: 12px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
    }
  }
  .alert_content {
    height: 167px;
    color: #333;
    .alert_title {
      text-align: center;
      margin-top: 27px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
      position: relative;
      font-size: 18px;
      span {
        position: absolute;
        top: 2px;
        right: 25px;
        color: #ac4b38;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .alert_text {
      width: calc(100% - 60px);
      margin: 0 auto;
      margin-top: 28px;
    }
  }
  .right_top {
    position: fixed;
    right: 15px;
    top: 10px;
    z-index: 10;
    .rt_img {
      width: 57px;
      height: 45px;
      position: absolute;
      right: 10px;
      top: 0;
    }
    .rt_text {
      margin-top: 60px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      font-family: PingFang-SC-Bold;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/coupon.vue